








import Vue from 'vue';
import Component from 'vue-class-component';
import CommonApi from '@/api/CommonApi';
import {Prop} from 'vue-property-decorator';
import {CodeRetrieveResponse} from '@/model/CommonModel';

@Component
export default class LanguageSelectInput extends Vue {
    @Prop({default: ''}) private readonly language: string;
    @Prop({default: 'small'}) private readonly size: string;
    
    private languages: CodeRetrieveResponse[] = [];
    
    get value() {
        return this.$route.meta.isAdmin ? null : this.$route.params.language;
    }

    get selectSize() {
        return this.size;
    }

    get getLanguages() {
      return this.$route.meta.isAdmin ? [] : this.languages;
    }
    
    public mounted() {
        CommonApi.retrieveCodes('USE_LANG').then(res => {
            this.languages = res.data.codeList;
        });
    }
    
    public onChangeInput(data: any) {
        this.$store.commit('setLanguage', data);
    }
}
